<template>
  <a-card :bordered="false">
    <div class="m-b-20 s_flex_bian_c">
      <a-button type="primary" v-has:guideActivityCreate=" () => { $router.push( '/guide/create?type=add' ); } " >
        <PlusOutlined />
        创建活动
      </a-button>
    </div>
    <!--  -->
    <a-form
      ref="form"
      :model="search"
      :style="{ marginBottom: '20px' }"
      :initialValues="search"
      :onFinish="pageSearchChange"
      layout="inline"
    >
      <a-form-item label="关键词" name="keyword">
        <a-input-group compact :style="{ width: '380px' }">
          <a-select v-model:value="search.key_type" style="width: 30%">
            <a-select-option value="activity_id">活动ID</a-select-option>
            <a-select-option value="activity_name">活动名称</a-select-option>
          </a-select>
          <a-input
            style="width: 70%"
            v-model:value="search.keyword"
            placeholder="请输入关键词进行搜索"
          />
        </a-input-group>
      </a-form-item>
      <a-form-item label="活动状态" name="status">
        <a-select v-model:value="search.status" :style="{ width: '180px' }">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">未开始</a-select-option>
          <a-select-option :value="2">进行中</a-select-option>
          <a-select-option :value="3">已结束</a-select-option>
          <!-- <a-select-option :value="4">已禁用</a-select-option> -->
        </a-select>
      </a-form-item>
      <a-form-item label="是否启用" name="is_open">
        <a-select v-model:value="search.is_open" :style="{ width: '180px' }">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType="submit">搜索</a-button>
      </a-form-item>
    </a-form>
    <div>
      <a-table
        :pagination="false"
        rowKey="activity_id"
        :loading="listLoading"
        bordered
        :columns="columns"
        :data-source="data"
        class="tableFixBox"
        :scroll="{ x: 'max-content' }"
      >
        <template #priority>
          <span>
            优先级
            <a-tooltip placement="right" :auto-adjust-overflow="false">
              <template #title>
                <p>
                  优先级数值越大代表优先级越高；若优先级相同，时间越新，优先级越高
                </p>
              </template>
              <QuestionCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <template v-slot:priorityContent="{ record }">
          <a-popconfirm
            @confirm="confirmSetSort(record)"
            @cancel="initData"
            class="m-r-10"
          >
            <template #title>
              <a-input-number
                v-model:value="record.sort_level"
                placeholder="优先级"
                :precision="0"
              />
            </template>
            <template #icon>
              <span></span>
            </template>
            {{ record.sort_level }}
            <FormOutlined />
          </a-popconfirm>
        </template>
        <template v-slot:ac_content="{ record }">
          <a-button
            class="ant-tag ant-tag-blue"
            v-has:guideActivityListSet="() => getRange(record)"
            >活动范围</a-button
          >
          <a-button
            class="ant-tag ant-tag-blue"
            v-has:guideActivityListSet="() => lookPrize(record)"
            >活动奖项</a-button
          >
        </template>
        <template v-slot:schedule="{ record }">
          <!-- status="exception" -->
          <a-progress :percent="record.plan" status="active" />
        </template>
        <template v-slot:action="{ record }">
          <!-- <a-button size="small" type="primary" ghost href="javascript:;" @click="$router.push('/guide/detail?type=edit&activity_id='+record.activity_id+'&activity_type='+record.activity_type)" class='m-r-10'>详情</a-button> -->
          <a-button
            type="primary"
            size="small"
            ghost
            class="m-r-10"
            v-has:guideActivityEdit="
              () => {
                $router.push(
                  record.activity_type == 1
                    ? '/guide/edit?type=edit&activity_id=' + record.activity_id
                    : '/guide/edit?type=edit&activity_id=' + record.activity_id
                );
              }
            "
            >编辑</a-button
          >
          <a-button
            type="primary"
            size="small"
            class="m-r-10"
            href="javascript:;"
            v-has:guideActivityStatus="() => switchStatus(record)"
            >{{ record.is_open == 1 ? "禁用" : "启用" }}</a-button
          >
          <a-button
            type="danger"
            size="small"
            href="javascript:;"
            v-has:guideActivityDel="() => del(record)"
            >删除</a-button
          >
        </template>
      </a-table>
      <a-pagination
        :style="{ marginTop: '10px', textAlign: 'right' }"
        show-size-changer
        show-quick-jumper
        :current="search.page"
        :page-size="search.limit"
        :total="total"
        @change="pageCurrentChange"
        @showSizeChange="pageSizeChange"
        :show-total="(total) => `总数: ${total} `"
      />
    </div>
  </a-card>

  <a-modal
    v-model:visible="rangeVisible"
    title="活动范围"
    centered
    :width="1200"
    :footer="null"
    destroyOnClose
  >
    <a-tabs v-if="rangeVisible">
      <a-tab-pane key="1" tab="批次">
        <range :activity_id="activity_id" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="出库单">
        <out :activity_id="activity_id" />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
  <!-- 按角色 -->
  <a-modal v-model:visible="awardVisible" title="活动奖项" :width="1000" :footer="null" centered destroyOnClose>
    <div class="m-b-15">活动二维码数量：{{listItemCount.code_num || 0}}</div>
    <a-table :pagination="false" :loading="listLoadingModal" bordered rowKey="award_id" :columns="columnslist" :data-source="list" >
    </a-table>
    <div class="m-t-15">当前活动已中奖数量：{{listItemCount.award_sure_num || 0}}（其中店老板同步发奖数量 {{listItemCount.boos_award_sure_num || 0}} 个）</div>
  </a-modal>
  <!-- 按概率 -->
  <a-modal v-model:visible="oddVisible" title="活动奖项" :width="1000" :footer="null" centered destroyOnClose>
    <div class="m-b-15">活动二维码数量：{{listItemCount.code_num || 0}}<span class="p-l-20">综合中奖率：{{listItemCount.percent || 0}}%</span></div>
    <a-table :pagination="false" :loading="listLoadingModal" bordered rowKey="award_id" :columns="columnsOdd" :data-source="oddList" >
      <template v-slot:award_content_arr="{ record }">
        <p v-for="item in record.award_content_arr" :key="item">{{item}}</p>
      </template>
    </a-table>
    <div class="m-t-15">当前活动已中奖数量：{{listItemCount.award_sure_num || 0}}（其中店老板同步发奖数量 {{listItemCount.boos_award_sure_num || 0}} 个）</div>
  </a-modal>
</template> 
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import {
  QuestionCircleOutlined,
  PlusOutlined,
  FormOutlined,
} from "@ant-design/icons-vue";
import range from "./components/range/index";
import out from "./components/out/index";
import award from "./components/award/index";
import { iscode } from "@/utils/app";
import {
  activitys,
  activitysSwitch,
  activitysDel,
  activitysOneDetail,
  getGuideOddsList,
  guideActivityAwardCount
} from "@/api/guide";
import { message, Modal } from "ant-design-vue";
import { result } from "lodash";
const def = {
  page: 1,
  limit: 10,
  status: "",
  key_type: "activity_name",
  keyword: "",
  is_open: "",
};
export default {
  name: "integralDetail",
  components: {
    QuestionCircleOutlined,
    PlusOutlined,
    FormOutlined,
    range,
    out,
    // award,
  },
  setup() {
    const state = reactive({
      listLoading: false,
      total: 0,
      rangeVisible: false, //活动范围
      awardVisible: false,//活动奖项-角色
      activity_id: "", //活动id
      oddList:[],//概率奖-列表
      oddVisible:false,//活动奖项-概率
      listLoadingModal:false,
      listItemCount:{}
    });
    let data = ref();

    let columnslist = [
      {
        title: "奖项名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "奖项内容",
        dataIndex: "bonus_id",
        key: "bonus_id",
      },
      {
        title: "指定对象发奖",
        dataIndex: "level_name",
        key: "level_name",
      },
    ];
    let columnsOdd = [
    {
          title: "奖项名称",
          dataIndex: "award_name",
          key: "award_name",
        },
        {
          title: "中奖码数量",
          dataIndex: "award_num",
          key: "award_num",
        },
        {
          title: "中奖概率",
          dataIndex: "percent",
          key: "percent",
          customRender: function ({ record }) {
            return record.percent + "%"
          },
        },
        {
          title: "奖项内容",
          dataIndex: "award_content_arr",
          key: "award_content_arr",
          slots: { customRender: "award_content_arr" },
        },
        {
          title: "已中奖数量",
          dataIndex: "award_sure_num",
          key: "award_sure_num",
        },
    ];
    let columns = [
      {
        title: "活动ID",
        dataIndex: "activity_id",
        key: "activity_id",
      },
      {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "活动时间",
        key: "schedule",
        width: 200,
        customRender: function ({ record }) {
          return record.start_time + "至" + record.end_time;
        },
      },
      {
        title: "活动设置",
        dataIndex: "ac_content",
        key: "ac_content",
        slots: { customRender: "ac_content" },
      },
      {
        title: "活动状态",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
        title: "是否启用",
        dataIndex: "is_open",
        key: "is_open",
        customRender: function ({ record }) {
          return record.is_open ? "启用" : "未启用";
        },
      },
      {
        key: "priority",
        slots: { title: "priority", customRender: "priorityContent" },
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
        customRender: function ({ record }) {
          return record.remarks ? record.remarks : "-";
        },
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $Modal = inject("$Modal");
    const list = ref([]);
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      let res = await activitys(search.value).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref(def);
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      initData(search.value);
    });
    const $router = inject("$router");
    // 修改优先级
    const confirmSetSort = async (data) => {
      console.log(data);
      let result = await activitysSwitch(data.activity_id, {
        sort_level: data.sort_level,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        initData(search.value);
      }
    };
    // 删除
    const del = async (data) => {
      $Modal.confirm({
        centered: true,
        title: "温馨提示",
        content: "确定要删除该活动么？",
        onOk: async () => {
          let res = await activitysDel(data.activity_id).then(
            (res) => res.data
          );
          if (iscode(res, true)) {
            initData(search.value);
          }
        },
      });
    };
    // 禁用启用
    const switchStatus = async (data) => {
      $Modal.confirm({
        centered: true,
        title: "温馨提示",
        content: `确定要${data.is_open == 1 ? "禁用" : "启用"}该活动么？`,
        onOk: async () => {
          let result = await activitysSwitch(data.activity_id, {
            is_open: 1 - Number(data.is_open),
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            initData(search.value);
          }
        },
      });
    };
    // 活动范围
    const getRange = async (data) => {
      state.activity_id = data.activity_id;
      state.rangeVisible = true;
    };
    // 查看活动奖项
    const lookPrize = async (data) => {
      state.activity_id = data.activity_id;
      if(data.send_award_type==1){
        getAward();
      }else{
        getOddsList();
      }
      getListItemCount();
    };
    
    //活动奖项-统计
    const getListItemCount = async () => {
      let res = await guideActivityAwardCount(state.activity_id).then((res) => res.data).catch((error) => error);
      if (iscode(res)) {
        state.listItemCount = res.data;
      } else {
        message.error(res.msg);
      }
    }
    //活动奖项-概率发奖列表
    const getOddsList = async () => {
      state.listLoadingModal = true;
      state.oddVisible = true;
      let res = await getGuideOddsList(state.activity_id).then((res) => res.data).catch((error) => error);
      state.listLoadingModal = false;
      if (iscode(res)) {
        state.oddList = res.data;
      } else {
        message.error(res.msg);
      }
    }
    // 活动奖项-按角色
    const getAward = async () => {
      state.listLoadingModal = true;
      state.awardVisible = true;
      let result = await activitysOneDetail(state.activity_id).then((res) => res.data).catch((error) => error);
      state.listLoadingModal = false;
      if (iscode(result, true)) {
        list.value = result.data.prize_data;
        // if (
        //   result.data.award_bonus_info instanceof Array &&
        //   result.data.award_point_info instanceof Array
        // ) {
        //   list.value.unshift({
        //     name: result.data.award_name,
        //     bonus_info: "",
        //     level_name: "-",
        //     id: 0,
        //     is_bonus: result.data.award_is_bonus,
        //     point_info: {
        //       point_num: "",
        //       point_content: "",
        //     },
        //     is_point: result.data.award_is_point,
        //   });
        // } else if (result.data.award_bonus_info instanceof Array) {
        //   list.value.unshift({
        //     name: result.data.award_name,
        //     bonus_info: "",
        //     level_name: "-",
        //     id: 0,
        //     is_bonus: result.data.award_is_bonus,
        //     point_info: {
        //       point_num: result.data.award_point_info.point_num,
        //       point_content: result.data.award_point_info.award_content,
        //     },
        //     is_point: result.data.award_is_point,
        //   });
        // } else if (result.data.award_point_info instanceof Array) {
        //   list.value.unshift({
        //     name: result.data.award_name,
        //     bonus_info: {
        //       bonus_id: result.data.award_bonus_info.bonus_id,
        //       bonus_name: result.data.award_bonus_info.bonus_name,
        //     },
        //     level_name: "-",
        //     id: 0,
        //     is_bonus: result.data.award_is_bonus,
        //     point_info: {
        //       point_num: "",
        //       point_content: "",
        //     },
        //     is_point: result.data.award_is_point,
        //   });
        // } else {
        //   list.value.unshift({
        //     name: result.data.award_name,
        //     bonus_info: {
        //       bonus_id: result.data.award_bonus_info.bonus_id,
        //       bonus_name: result.data.award_bonus_info.bonus_name,
        //     },
        //     level_name: "-",
        //     id: 0,
        //     is_bonus: result.data.award_is_bonus,
        //     point_info: {
        //       point_num: result.data.award_point_info.point_num,
        //       point_content: result.data.award_point_info.point_content,
        //     },
        //     is_point: result.data.award_is_point,
        //   });
        // }
     list.value.forEach((item) => {
          if (item.bonus_info == "" && item.point_info == "") {
            item.bonus_id = "";
          } else if (item.bonus_info != "" && item.point_info == "") {
            item.bonus_id = item.bonus_info.bonus_name;
          } else if (item.bonus_info != "" && item.point_info != "") {
            item.bonus_id =
              item.bonus_info.bonus_name + item.point_info.point_num+"积分";
          } else if(item.bonus_info == "" && item.point_info != ""){
            item.bonus_id = item.point_info.point_num+"积分";
          }
        });
      }
    };

    return {
      ...toRefs(state),
      search,
      data,
      columns,
      columnslist,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
      confirmSetSort,
      del,
      switchStatus,
      getRange,
      getAward,
      list,
      columnsOdd,
      getOddsList,
      lookPrize
    };
  },
};
</script>